// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReviewSuggestionCountFragment = { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, dpFirstDeathGrantorClientProfile?: { __typename?: 'ClientProfile', id: string } | null, onboardingEntity?: { __typename?: 'OnboardingEntitySuggestion', entityKind?: Types.EntityKind | null } | null, entity?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, stage: Types.EntityStage } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string } | null };

export type ReviewSuggestionCountsQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type ReviewSuggestionCountsQuery = { __typename?: 'Query', aiSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & ReviewSuggestionCountFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    ReviewSuggestionCounts: 'ReviewSuggestionCounts' as const
  },
  Fragment: {
    ReviewSuggestionCount: 'ReviewSuggestionCount' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ReviewSuggestionCountFragmentDoc = gql`
    fragment ReviewSuggestionCount on AISuggestion {
  id
  kind
  dpFirstDeathGrantorClientProfile {
    id
  }
  onboardingEntity {
    entityKind
  }
  entity {
    id
    kind
    stage
  }
  testamentaryEntity {
    id
  }
}
    `;
export const ReviewSuggestionCountsDocument = gql`
    query ReviewSuggestionCounts($householdId: ID!) {
  aiSuggestions(
    where: {hasHouseholdWith: [{id: $householdId}], acceptanceStatusIsNil: true, kindNotIn: [ONBOARDING_INDIVIDUAL, ONBOARDING_ORGANIZATION], version: 2}
  ) {
    edges {
      node {
        ...ReviewSuggestionCount
      }
    }
  }
}
    ${ReviewSuggestionCountFragmentDoc}`;

/**
 * __useReviewSuggestionCountsQuery__
 *
 * To run a query within a React component, call `useReviewSuggestionCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewSuggestionCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewSuggestionCountsQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useReviewSuggestionCountsQuery(baseOptions: Apollo.QueryHookOptions<ReviewSuggestionCountsQuery, ReviewSuggestionCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewSuggestionCountsQuery, ReviewSuggestionCountsQueryVariables>(ReviewSuggestionCountsDocument, withFetchPolicyContext(options));
      }
export function useReviewSuggestionCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewSuggestionCountsQuery, ReviewSuggestionCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewSuggestionCountsQuery, ReviewSuggestionCountsQueryVariables>(ReviewSuggestionCountsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useReviewSuggestionCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReviewSuggestionCountsQuery, ReviewSuggestionCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewSuggestionCountsQuery, ReviewSuggestionCountsQueryVariables>(ReviewSuggestionCountsDocument, withFetchPolicyContext(options));
        }
export type ReviewSuggestionCountsQueryHookResult = ReturnType<typeof useReviewSuggestionCountsQuery>;
export type ReviewSuggestionCountsLazyQueryHookResult = ReturnType<typeof useReviewSuggestionCountsLazyQuery>;
export type ReviewSuggestionCountsSuspenseQueryHookResult = ReturnType<typeof useReviewSuggestionCountsSuspenseQuery>;
export type ReviewSuggestionCountsQueryResult = Apollo.QueryResult<ReviewSuggestionCountsQuery, ReviewSuggestionCountsQueryVariables>;